import { IToken } from '../typings/token';


export function isScalaType(t: string) {
  return [
    'Declaration',
    'CustomProperty',
    'FqnProperty',
    'Placeholder',
    'ModelProperty',
    'Boolean',
    'Integer',
    'Number',
    'String',
    'Null',
    'Atom'
  ].includes(t);
}

export function isCalculatableType(t: string) {
  return isScalaType(t) ||
    t === 'FunctionCall' ||
    t === 'IdentifierArray';
}


/**
 * 获取括号结束位置，如左括号对应的右括号的位置
 * start 为左括号的位置
 */
export function getCloseBracketTokenPosition(
  start: number,
  tokens: IToken[],
  openBracket: string,
  closeBracket: string
) {
  let i = start + 1;
  let bracketCount = 1;
  while (i < tokens.length && bracketCount > 0) {
    const itoken = tokens[i++];
    if (itoken.type === openBracket) {
      bracketCount++;
    } else if (itoken.type === closeBracket) {
      bracketCount--;
    }
  }

  if (bracketCount > 0) {
    return -1;
  }

  return i - 1;
}



// 判断是否为正确的日期格式
export function isAcceptableDate(v: string) {
  return /^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))$/.test(v);
}


// 判断是否为正确的时间格式
export function isAcceptableTime(v: string) {
  // return /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9]):([0-5]?[0-9])$/.test(v);
  return /^(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])$/.test(v);
}


// 判断是否为正确的ISO时间格式
export function isAcceptableDateTime(v: string) {
  // tslint:disable-next-line
  return /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$/.test(v);
}
